const stringifyGeometry = points =>
  points
    ? JSON.stringify({
        type: 'LineString',
        coordinates: points,
      })
    : null;

export default stringifyGeometry;
